import { render, staticRenderFns } from "./hotTemplate.vue?vue&type=template&id=26859178&scoped=true"
import script from "./hotTemplate.vue?vue&type=script&lang=js"
export * from "./hotTemplate.vue?vue&type=script&lang=js"
import style0 from "./hotTemplate.vue?vue&type=style&index=0&id=26859178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26859178",
  null
  
)

export default component.exports